import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import slide1 from '../../assets/slide-1.jpg';
import slide2 from '../../assets/slide-2.jpg';
import slide3 from '../../assets/slide-3.jpg';
import './MemberBenefitSlides.css';

const MEMBER_BENEFIT_SLIDES = [
  {
    src: slide1,
    alt: 'Play your favorite games online and earn WScore'
  },
  {
    src: slide2,
    alt: 'Redeem your WScore for prizes like FREE Play, Food Credit, and more!'
  },
  {
    src: slide3,
    alt: 'Visit your favorite Wind Creek property and use your prizes'
  }
];

const SLIDE_INTERVAL = 3000;

function MemberBenefitSlides() {
  return (
    <div className="member-benefits-slides">
      <Carousel
        className="carousel"
        indicators={false}
        wrap={true}
        interval={SLIDE_INTERVAL}
        controls={false}
      >
        {MEMBER_BENEFIT_SLIDES.map((slide, index) => (
          <Carousel.Item key={index}>
            <img src={slide.src} alt={slide.alt} />
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
}

export default MemberBenefitSlides;
